import React, { useContext, useState, useEffect } from 'react'
import { Video } from '@bhvr/web-design-system'

import { GeolocalizationContext } from '../../utils/contexts/geolocalization-context'
import AgeGate from './age-gate/age-gate'

const VideoPlayer = (props) => {
  const randomID = Math.floor(Math.random() * 100) + Date.now()
  const dataID = props.id ? props.id : randomID

  // Game Rating Informations
  const { ageGate, rating, legalAge, formSubmit } = useContext(GeolocalizationContext)
  const [gameRating, setGameRating] = rating
  const [isLegalAge, setLegalAge] = legalAge
  const [ageGateSettings, setAgeGateSettings] = ageGate
  const [formSubmitted, setFormSubmitted] = formSubmit
  const [videoPlay, setVideoPlay] = useState(false)

  // Video Age Gate data
  const ageGateData = props.ageGateData && props.ageGateData !== null ? props.ageGateData : ''
  const stringsDates = props.strings && props.strings.dates ? props.strings.dates : ''
  const stringsErrors = props.strings && props.strings.errors ? props.strings.errors : ''

  // Load Video
  const loadGatedVideo = () => {
    if (ageGateData && ageGateSettings && ageGateSettings.enabled) {
      if (isLegalAge) {
        setVideoPlay(true)
      } else {
        setAgeGateSettings(prev => ({ ...prev, displayed: true, usage: dataID }))
      }
    } else {
      setVideoPlay(true)
    }
  }
  useEffect(() => {
    if (props.isPopup) {
      loadGatedVideo()
    }
  }, [isLegalAge])

  useEffect(() => {
    if (formSubmitted && isLegalAge) {
      setVideoPlay(true)
    }
  }, [formSubmitted])

  return (
    <div className={`video-player relative`}>
      <div
        className={props.wrapperClassName ? props.wrapperClassName : 'relative'}
        onClick={loadGatedVideo}
      >
        <Video
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          loading="lazy"
          lazy={true}
          ageGated={ageGateSettings && ageGateSettings.enabled ? true : false}
          isPlaying={videoPlay}
          autoplay
          pauseBtnClassName="video-pause-small absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          pauseBtnLabel="Pause"
          playBtnLabel="Play"
          className={props.className}
          player={props.player ? props.player : 'youtube'}
          playsInline
          poster={props.poster}
          source={props.source}
          rating={process.env.GATSBY_GEOLOCALIZATION && (process.env.GATSBY_GEOLOCALIZATION === true || process.env.GATSBY_GEOLOCALIZATION === 'true') ? (gameRating && gameRating !== null ? (gameRating.logo.url ? gameRating.logo.url : gameRating.logo.publicURL) : null) : null}
          ratingClassName={`video-rating-logo ${gameRating && gameRating.code ? gameRating.code : ''}`}
          ratingTimeBuffer={`${props.ratingTimeBuffer && props.ratingTimeBuffer !== null ? props.ratingTimeBuffer : 0}`}
        >
          {props.children}
        </Video>
      </div>
      {ageGateSettings && ageGateSettings.enabled && ageGateData && !isLegalAge && (
        <AgeGate
          dataID={dataID}
          data={ageGateData}
          type={props.isPopup ? 'modal' : 'video'}
          strings={{ errors: stringsErrors, dates: stringsDates }}
          dateFormat={props.pageContext && props.pageContext.locale === 'ja' ? 'yyyy-mm-dd' : 'dd-mm-yyyy'}
          pageContext={props.pageContext}
          eventSection={props.eventSection}
        />
      )}
    </div>
  )
}

export default VideoPlayer
